import React from "react";
import AuditorForm from "./AuditorForm";

export default function AuditorEditPage() {
  return <AuditorForm isEditMode />;
}
